<template>
  <router-link
    :to="to"
    class="btn btn-light border-muted"
    v-b-tooltip :title="label"
  >
    <IconPlus class="fill-color" width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true"/>
  </router-link>
</template>

<script>
import IconPlus from '@primer/octicons/build/svg/plus-16.svg'

export default {
  name: 'NewButton',
  components: {
    IconPlus,
  },
  props: {
    label: {
      type: String,
      default: 'New',
    },
    to: {
      default() { return {path: 'new', append: true} },
    },
  },
}
</script>
